module.exports = __webpack_public_path__ + "img/camping-3.916bc209.jpg";